import { useQuery } from "@tanstack/react-query";
import { fetchLocalisationKeys } from "PFCore/services/admin/localisation/fetch_localisation_keys";
import { PaginatedCollection } from "PFTypes";
import { Localisation, LocalisationKeys } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { queryKeys } from "./query_keys";

export const useLocalisationKeys = (
  accountId: number,
  key: LocalisationKeys,
  page: number,
  options?: QueryOptions<PaginatedCollection<Localisation[]>>
) =>
  useQuery(
    queryKeys.localisationPage(accountId, key, page),
    () => fetchLocalisationKeys({ accountId, key, page, perPage: 20 }),
    options
  );
